/** The cubic docs site. */
export const DOCS_URL = 'https://docs.cubic.dev';

/** The changelog on the docs site. cubic.dev/changelog redirects here (next.config.ts). */
export const DOCS_CHANGELOG_URL = 'https://docs.cubic.dev/changelog';

/** RSS feed for the changelog, generated by Mintlify (`rss: true` in docs/changelog.mdx). */
export const DOCS_CHANGELOG_RSS_URL = `${DOCS_CHANGELOG_URL}/rss.xml`;

/** The cubic MCP server guide. */
export const MCP_SERVER_DOCS_URL = `${DOCS_URL}/ide/mcp-server`;

/** The cubic CLI guide. */
export const CLI_DOCS_URL = `${DOCS_URL}/ide/cli-review`;

/** The Members API guide, for personal and organization API keys. */
export const MEMBERS_API_DOCS_URL = `${DOCS_URL}/account/members-api`;

/** The Analytics API guide. */
export const ANALYTICS_API_DOCS_URL = `${DOCS_URL}/analytics/api`;
